import { Button } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import React from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enUS } from "date-fns/esm/locale";
import { isValidDate } from "../../../../../../../../ui library/helpers/dates";

export default function DatePickerFilter({
  id,
  title,
  selectedValue,
  setSelectedValue,
  updateFilter,
  isActive,
  setActiveChipLabel,
}) {
  const currentDate = new Date();

  const handleOnDateChange = (newValue) => {
    if (!!newValue && !isValidDate(newValue)) return;

    const newDate = !newValue ? null : new Date(newValue).toLocaleDateString();
    setSelectedValue(id, newValue);
    setActiveChipLabel(id, newDate);
    updateFilter(id, newDate);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enUS}>
      <DatePicker
        className="w-full ml-1 my-1 text-center"
        label={title}
        value={selectedValue ?? currentDate}
        onChange={(newValue) => handleOnDateChange(newValue)}
        slotProps={{ textField: { variant: "outlined" } }}
      />
      
      {!selectedValue ? (
        ""
      ) : (
        <div className="p-2">
          <Button
            onClick={() => handleOnDateChange(null)}
            className="text-sm text-red-600 border-red-600 px-0 hover:bg-red-600 hover:text-white"
          >
            X
          </Button>
        </div>
      )}
    </LocalizationProvider>
  );
}
